/**
 * The header row of a list-table (a flex list laid out in columns; TMMAPP-0099, visual contract
 * §10): 11/500, 0.06em, uppercase, in the card's `textLabel` (`text3`, or `text2` where `text3`
 * falls short of 4.5:1), padding 8 20, over a `line` rule. The children are the column labels, laid out by the caller's `columns` (a CSS grid template) to match its rows. It is
 * not a table: a row's own text carries every value, so the header is hidden from assistive
 * technology, as the prototype's is decoration over self-describing rows.
 */
import type { ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { resolveTokens } from '@/theme/theme';

interface ListTableHeaderProps {
  children: ReactNode;
  /** The rows' `grid-template-columns`. */
  columns: string;
}

export function ListTableHeader({ children, columns }: ListTableHeaderProps) {
  const tokens = resolveTokens(useTheme());
  return (
    <Box
      aria-hidden
      data-list-table-header=""
      sx={{
        display: 'grid',
        gridTemplateColumns: columns,
        columnGap: 2,
        alignItems: 'center',
        p: '8px 20px',
        borderBottom: `1px solid ${tokens.line}`,
        typography: 'kindLabel',
        color: tokens.textLabel('surface'),
      }}
    >
      {children}
    </Box>
  );
}
